import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import CustomizableTable from "../Tables/CustomizableTable";
import { MAIN_COLUMN_WIDTH } from "../Tables/SortableTable";
import {
	activeStatusTabFilterMap,
	statusColumn,
} from "../Tables/tagTableShared";
import { settingsRoutes } from "../../config/routes";

const columnConfig = [
	{
		Header: "Location",
		accessor: "name",
		width: MAIN_COLUMN_WIDTH,
		wildcard: true,
	},
	statusColumn,
	{ Header: "Created By", accessor: "createdBy", wildcard: true },
];

const FirmLocationsTable = ({ officeBranches }) => (
	<div>
		<CustomizableTable
			tabsFilterMap={activeStatusTabFilterMap}
			defaultTabFilterValue="Active"
			className="fullWidth"
			data={officeBranches}
			columns={columnConfig}
			noResultsText="No locations here"
			tableUniqueID="/myFirm/locations"
			tableStyle={{ height: 220 }}
			hideColumnsButton
			noAutoResize
		/>
		<div style={{ marginTop: 16 }}>
			<Link to={settingsRoutes.MANAGE_OFFICE_BRANCH.href}>
				Manage Locations
			</Link>
		</div>
	</div>
);

const mapStateToProps = (state) => ({
	officeBranches: state.matter.availableOfficeBranches,
});

export default connect(mapStateToProps)(FirmLocationsTable);
